/* eslint-disable indent */
import * as actions from "../actions/actionTypes";

const appReducer = (state = {}, action) => {
  switch (action.type) {
    case actions.SET_CURRENT_PAGE:
      return {
        ...state,
        currentPage: action.currentPage,
      };

    /*case actions.SET_ANALYZE:
      return {
        ...state,
        analyzeSelected: action.analyzeSelected
      };*/

    default:
      return state;
  }
};

export default appReducer;
